import { ConfirmationModal } from 'components/confirm-modal/modal';
import { useDeleteVhcRecordVideoMutation } from 'features/vhc/api/delete-vhc-records-video.mutation copy';
import { FC } from 'react';

type Props = {
  isVisible: boolean;
  id?: number;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  setInProgress: React.Dispatch<React.SetStateAction<boolean>>;
  refetch: () => void;
};

export const VideoDeleteModal: FC<Props> = ({ id, setOpenModal, setInProgress, refetch }) => {
  const { mutateAsync: deleteVideoMutation, isLoading: isRecordDeleting } = useDeleteVhcRecordVideoMutation();

  const handleConfirm = () => {
    setInProgress(true);
    deleteVideoMutation({ id: id! })
      .then(refetch)
      .catch((_) => setInProgress(false));
  };

  const handleCancel = () => {
    setOpenModal(false);
  };

  return (
    <ConfirmationModal
      title="Confirm to delete video"
      message={'Are you sure to delete video?'}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      isSubmitting={isRecordDeleting}
    />
  );
};
